import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useImageContentControlsContext } from "~/components/AssetModalV2/Content/ImageContentControlsContextProvider";
import { MAX_ZOOM, MIN_ZOOM } from "~/components/AssetModalV2/Visualizer/ImageVisualizer/shared/constants";
import { ZoomSlider } from "./ZoomSlider";
export const ImageZoomSlider = /*#__PURE__*/ memo(()=>{
    const { zoom, onZoomIn, onZoomOut } = useImageContentControlsContext();
    const handleSliderChange = useCallback((value)=>{
        const newZoom = value[0];
        if (newZoom > zoom) {
            onZoomIn();
        } else if (newZoom < zoom) {
            onZoomOut();
        }
    }, [
        onZoomIn,
        onZoomOut,
        zoom
    ]);
    return /*#__PURE__*/ _jsx(ZoomSlider, {
        onZoomIn: onZoomIn,
        onZoomOut: onZoomOut,
        zoom: zoom,
        onSliderChange: handleSliderChange,
        min: MIN_ZOOM,
        max: MAX_ZOOM,
        step: 0.5
    });
});
ImageZoomSlider.displayName = "ImageZoomSlider";
